module.exports = __webpack_public_path__ + "static/media/download-undraw.90c940f7.png";